import { X } from '@ui/components/icons';
import { Portal } from '@ui/lib/park/portal';
import { Button } from '@ui/lib/park/ui/button';
import { Dialog } from '@ui/lib/park/ui/dialog';
import { Icon } from '@ui/lib/park/ui/icon';
import { Skeleton } from '@ui/lib/park/ui/skeleton';
import { Text } from '@ui/lib/park/ui/text';
import { useEffect, useState } from 'react';
import { Flex, HStack, styled } from 'styled-system/jsx';

export const AlphaMarketIntroModal = ({
  isOpen,
  onClose,
  onConfirm,
}: {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}) => {
  const [isImgLoaded, setIsImgLoaded] = useState(false);

  useEffect(() => {
    if (isOpen) setIsImgLoaded(false);
  }, [isOpen]);

  return (
    <Dialog.Root
      lazyMount
      unmountOnExit
      modal={false}
      closeOnInteractOutside={false}
      open={isOpen}
      onOpenChange={(e) => {
        if (!e.open) onClose();
      }}
      type="desktopModal_mobileDrawer"
    >
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content>
            <Dialog.Title asChild>
              <Flex
                justifyContent="space-between"
                alignItems="center"
                p="16px"
                borderBottom="1px solid"
                borderColor="v2.border.default"
              >
                <Text>Alpha Market</Text>
				<Dialog.CloseTrigger boxShadow="none" bg="none">
                  <Icon w="20px" h="20px">
                    <X />
                  </Icon>
                </Dialog.CloseTrigger>
              </Flex>
            </Dialog.Title>

            <Dialog.Description
              p={4}
              pt={5}
              gap={4}
              display="flex"
              flexDir="column"
            >
              <Skeleton
                w="full"
                // keep layout stable while SVG loads
                aspectRatio={342 / 317}
                bg="v2.bg.surface1"
                borderRadius="4px"
                overflow="hidden"
                isLoaded={isImgLoaded}
              >
                <styled.img
                  src="/images/alpha-market.svg"
                  alt="alpha-market"
                  width="100%"
                  onLoad={() => setIsImgLoaded(true)}
                  onError={() => setIsImgLoaded(true)}
                  style={{
                    display: 'block',
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                  }}
                />
              </Skeleton>

              <HStack gap={4} mt={2}>
                <Button w="full" size="mid" variant="primary" onClick={onConfirm}>
				  Acknowledge
                </Button>
              </HStack>
            </Dialog.Description>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};


